import { createBreakpoints } from '@mui/system';

const breakpoints = createBreakpoints({});

export const h1Custom = {
  fontSize: 28,
  lineHeight: 1.2,
  fontFamily: 'LexendDeca',
  fontWeight: 600,
  [breakpoints.down('sm')]: {
    fontSize: 20,
  },
  [breakpoints.up('sm')]: {
    fontSize: 30,
  },
  [breakpoints.up('md')]: {
    fontSize: 32,
    '@media (min-resolution: 1.25dppx)': {
      fontSize: 28,
    },
  },
  [breakpoints.up('lg')]: {
    fontSize: 34,
    '@media (min-resolution: 1.25dppx)': {
      fontSize: 26,
    },
  },
};

export const h2Custom = {
  fontSize: 16,
  lineHeight: 1.2,
  fontFamily: 'LexendDeca',
  fontWeight: 600,
  [breakpoints.up('sm')]: {
    fontSize: 22,
    '@media (min-resolution: 1.25dppx)': {
      fontSize: 16,
    },
    '@media (min-height: 1000px)': {
      fontSize: 24,
    },
  },
  [breakpoints.up('md')]: {
    fontSize: 28,
    '@media (max-width: 1100px)': {
      fontSize: 16,
    },
    '@media (min-resolution: 1.25dppx)': {
      fontSize: 18,
    },
  },
  [breakpoints.up('xl')]: {
    '@media (min-resolution: 1.25dppx)': {
      fontSize: 22,
    },
  },
};

export const h3Custom = {
  fontSize: 18,
  lineHeight: 1.2,
  fontFamily: 'LexendDeca',
  fontWeight: 600,
  textWrap: 'balance',

  '@media(min-width: 1025px) and (max-width: 1112px) and (max-height: 675px)': {
    fontSize: '13.5px!important',
  },

  [breakpoints.down('sm')]: {
    fontSize: 15,
  },
  [breakpoints.up('sm')]: {
    fontSize: 16,
  },
  [breakpoints.up('md')]: {
    fontSize: 18,
    '@media (min-resolution: 1.25dppx)': {
      fontSize: 14,
    },
  },

  [breakpoints.up('lg')]: {
    fontSize: 18,
    '@media (min-resolution: 1.25dppx)': {
      fontSize: 15.5,
    },
  },
};

export const h4Custom = {
  fontSize: 14,
  lineHeight: 1.2,
  fontFamily: 'LexendDeca',
  fontWeight: 500,
  [breakpoints.down('sm')]: {
    fontSize: 14,
  },
  [breakpoints.up('sm')]: {
    fontSize: 14,
  },
  [breakpoints.up('md')]: {
    fontSize: 14,
    '@media (min-resolution: 1.25dppx)': {
      fontSize: 12,
    },
  },
  [breakpoints.up('lg')]: {
    fontSize: 16,
    '@media (min-resolution: 1.25dppx)': {
      fontSize: 12,
    },
  },
};

export const h5Custom = {
  fontSize: 13,
  lineHeight: 1.2,
  fontFamily: 'LexendDeca',
  fontWeight: 400,
  [breakpoints.down('sm')]: {
    fontSize: 13,
  },
  [breakpoints.up('sm')]: {
    fontSize: 13,
  },
  [breakpoints.up('md')]: {
    fontSize: 14,
  },
  [breakpoints.up('lg')]: {
    fontSize: 14,
  },
};

export const h6Custom = {
  fontSize: 10,
  lineHeight: 1.2,
  fontFamily: 'LexendDeca',
  fontWeight: 400,
  [breakpoints.down('sm')]: {
    fontSize: 10,
  },
  [breakpoints.up('sm')]: {
    fontSize: 12,
  },
  [breakpoints.up('md')]: {
    '@media (max-width: 1100px)': {
      fontSize: 12,
    },
    fontSize: 14,
  },
  [breakpoints.up('lg')]: {
    fontSize: 16,
  },
};

export const s1Custom = {
  fontSize: 11,
  lineHeight: 1.2,
  fontFamily: 'Nunito',
  fontWeight: 900,
  [breakpoints.down('sm')]: {
    fontSize: 16,
  },
  [breakpoints.up('sm')]: {
    fontSize: 16,
  },
  [breakpoints.up('md')]: {
    fontSize: 16,
  },
  [breakpoints.up('lg')]: {
    fontSize: 18,
  },
};

export const s2Custom = {
  fontSize: 13,
  lineHeight: 1.2,
  fontFamily: 'Nunito',
  fontWeight: 600,
  [breakpoints.down('sm')]: {
    fontSize: 10,
  },
  [breakpoints.up('sm')]: {
    fontSize: 12,
  },
  [breakpoints.up('md')]: {
    fontSize: 12,
  },
  [breakpoints.up('lg')]: {
    fontSize: 14,
  },
};

export const b1Custom = {
  fontSize: 12,
  lineHeight: 1.2,
  fontFamily: 'Nunito',
  fontWeight: 400,
  [breakpoints.down('sm')]: {
    fontSize: 16,
  },
  [breakpoints.up('sm')]: {
    fontSize: 16,
  },
  [breakpoints.up('md')]: {
    '@media (max-width: 1100px)': {
      fontSize: 12,
    },
    fontSize: 16,
  },
  [breakpoints.up('lg')]: {
    fontSize: 14,
  },
  '@media (min-width: 1537px)': {
    fontSize: 16,
  },
};

export const b2Custom = {
  fontSize: 12,
  lineHeight: 1.2,
  fontFamily: 'Nunito',
  fontWeight: 9900,
  color: '#4f5f71',
  [breakpoints.down('sm')]: {
    fontSize: 12,
  },
  [breakpoints.up('sm')]: {
    fontSize: 14,
  },
  [breakpoints.up('md')]: {
    '@media (max-width: 1100px)': {
      fontSize: 12,
    },
    fontSize: 14,
  },
  [breakpoints.up('lg')]: {
    fontSize: 14,
  },
};

export const captionCustom = {
  fontSize: 10,
  lineHeight: 1.2,
  fontFamily: 'Nunito',
  fontWeight: 600,
  [breakpoints.down('sm')]: {
    fontSize: 10,
  },
  [breakpoints.up('sm')]: {
    fontSize: 12,
  },
  [breakpoints.up('md')]: {
    fontSize: 11,
  },
  [breakpoints.up('lg')]: {
    fontSize: 11,
  },
};
